export default{
    hwxx: '货物信息',
    dxyd: '单箱运单',
    plzjxs: '批量增加箱数',
    xzh: '新增行',
    sch: '删除行',
    xuhao: '序号',
    xzhwmc: '货物名称',
    pinl: '品类',
    twbh: '铁危编号',
    xianh: '箱号',
    qsrxh: '请输入箱号',
    xianshu: '箱属',
    tielux: '铁路箱',
    zibeix: '自备箱',
    xianx: '箱型',
    xianl: '箱类',
    kongz: '空重',
    kong: '空',
    zhong: '重',
    baozhuan: '包装',
    cpchx: '重去重回箱',
    tielcdx: '铁路敞顶箱',
    tezx: '特种箱',
    cquch: '重去重回',
    xiasch: '下水重回',
    sfh: '施封号',
    zhognlqk: '重量(千克)',
    jiage: '价格(元)',
    msg1: '*货物名称说明：若在货物品名中查找不到相应品名，可在下方填写品名，并选择相应品类。发送自备集装箱且箱内无货物，品名请选择自备集装箱（或集装箱）。',
    msg2: '填记其他品名（如：空箱、空自备箱等），系统将按重箱计费。',
    ri: '日',
    rysxq: '日运输需求',
    zyrq: '装运日期',
    xzrq: '选择日期',
    xqtcfs: '需求提出方式',
    zjtcrxq: '直接提出日需求',
    syjdxq: '使用阶段需求',
    jdxqh: '阶段需求号',
    qsrjdxqh: '请输入阶段需求号',
    ches: '车数',
    chec: '车次',
    liang: '两',
    ldwl: '两端物流',
    msg3: '可根据您的需求，选择录入发到站接取，送达，仓储等物流服务信息。',
    mdz: '门到站',
    smqh: '上门取货',
    zdm: '站到门',
    lxrxm: '联系人姓名',
    dianh: '电话',
    qhdz: '取货地址',
    qianmi: '千米',
    licheng: '里程',
    tyrqdjs: '托运人确定件数',
    xuqsm: '需求说明',
    qhgsfy: '取货估算费用',
    smsh: '上门送货',
    shdz: '送货地址',
    tijiao: '提交',
    qink: '清空',
    chax: '查询',
    yslx: '运输类型',
    tuoyf: '托运方',
    souhf: '收货方',
    hwpm: '货物品名',
    slcs: '受理车数',
    caoz: '操作',
    xuanzhe: '选择',
    xzjdxqh: '选择阶段需求号',
    shgsfy: '送货估算费用',
}

